import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const fetchConnectionInfo = createAction(`${reduxKey}/AUTHOR/GET_CONNECTION`, ()=>({}));
export const updateConnectionInfo = createAction(`${reduxKey}/AUTHOR/UPDATE_CONNECTION`, (connectionInfo)=>connectionInfo);
export const fetchRoles = createAction(`${reduxKey}/AUTHOR/GET_ROLES`, ()=>({}));
export const updateRoles = createAction(`${reduxKey}/AUTHOR/UPDATE_ROLES`, (roles)=>({
        roles
    }));
export const connect = createAction(`${reduxKey}/AUTHOR/CONNECT`, (oauth2Link)=>({
        oauth2Link
    }));
export const connectionSuccess = createAction(`${reduxKey}/AUTHOR/CONNECT_SUCCESS`, (justNow)=>({
        justNow
    }));
export const connectionFail = createAction(`${reduxKey}/AUTHOR/CONNECT_FAIl`, ()=>({}));
export const disconnect = createAction(`${reduxKey}/AUTHOR/DISCONNECT`, ()=>({}));
export const disconnectSuccess = createAction(`${reduxKey}/AUTHOR/DISCONNECT_SUCCESS`, ()=>({}));
export const disconnectFail = createAction(`${reduxKey}/AUTHOR/DISCONNECT_FAIL`, ()=>({}));
export const subscriberConnect = createAction(`${reduxKey}/SUBSCRIBER/CONNECT`, (tier)=>{
    var _tier_tier, _tier_tier_discord;
    return {
        oauth2Url: (_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : (_tier_tier_discord = _tier_tier.discord) === null || _tier_tier_discord === void 0 ? void 0 : _tier_tier_discord.oauth2
    };
});
export const subscriberConnectSuccess = createAction(`${reduxKey}/SUBSCRIBER/CONNECT_SUCCESS`, (guildId)=>({
        guildId
    }));
export const subscriberConnectFail = createAction(`${reduxKey}/SUBSCRIBER/CONNECT_FAIL`, ()=>({}));
